// @flow
import React from 'react'
import './styles.scss'
// https://reactjsexample.com/a-very-simple-echarts-wrapper-for-react/
import ReactEcharts from 'echarts-for-react'
import echarts from 'echarts'
import { Link } from '@ta-interaktiv/contentbricks'

const monthNames = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember'
]

const months = [
  'Jan',
  'Feb',
  'Mär',
  'Apr',
  'Mai',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Okt',
  'Nov',
  'Dez'
]

// Generate mock data
// const data = []
// const dataCount = 157
/*
echarts.util.each(months, function(category, index) {
  for (let i = 0; i < dataCount; i++) {
    const typeItem = types[Math.round(Math.random() * (types.length - 1))]
    const year = 1864
    data.push({
      name: typeItem.name,
      value: [index, year, year + 1, 1],
      itemStyle: {
        normal: {
          color: typeItem.color
        }
      }
    })
  }
  console.log('### MOCK DATA ###', data)
})
*/

let stripeMargin = 0.5

function renderItem(params, api) {
  const categoryIndex = api.value(0)
  const start = api.coord([api.value(1), categoryIndex])
  const end = api.coord([api.value(2), categoryIndex])
  const height = api.size([0, 1])[1] * 0.97

  const rectShape = echarts.graphic.clipRectByRect(
    {
      x: start[0],
      y: start[1] - height / 2,
      width: end[0] - start[0] - stripeMargin,
      height: height
    },
    {
      x: params.coordSys.x,
      y: params.coordSys.y,
      width: params.coordSys.width,
      height: params.coordSys.height
    }
  )

  return (
    rectShape && {
      type: 'rect',
      shape: rectShape,
      style: api.style()
    }
  )
}

export class TempStripes extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800,
      displayData: {},
      chartOptions: {},
      echartInstance: null,
      referencePeriod: '1991-2020', // '1981-2010', // 1961-1990,
      highlightItem: -1,
      highlightTemp: 9999,
      zoomStart: -1,
      zoomEnd: -1
    }
    this.handleEvents = {
      dataZoom: this.onZoom,
      mouseout: this.onChartLeave
    }
  }

  onZoom = params => {
    // console.log('+++++ params ++++')
    // console.log(params)
    // console.log('start: ', params.start)
    // console.log('end: ', params.end)
    const zoomRange = params.end - params.start
    // console.log('zoomRange:', zoomRange)
    // console.log('zoom stripeMargin:', stripeMargin)
    stripeMargin = this.state.isMobile ? 0 : zoomRange / 200

    this.setState({
      zoomStart: params.start,
      zoomEnd: params.end
    })
  }

  onChartLeave = params => {
    // console.log('+++++ params ++++')
    // console.log(params)
    this.setState(
      {
        highlightItem: -1
      },
      () => {
        // console.log('#### highlightItem ####', this.state.highlightItem)
        this.state.echartInstance.setOption(this.getOption())
      }
    )
  }

  componentDidMount() {
    // prepare Data according to set lastMonth
    const rawDates = this.props.lastMonth.split('-')
    const lastYear = parseInt(rawDates[0])
    const lastMonth = parseInt(rawDates[1])
    const displayData = this.props.data
    const yearIndex = this.props.data.years.findIndex(x => x.year === lastYear)
    if (yearIndex >= 0) {
      const displayYears = this.props.data.years.slice(0, yearIndex + 1)
      const displayMonths = displayYears[yearIndex].months.slice(0, lastMonth)
      const displayDeltas = displayYears[yearIndex].reference_deltas[
        this.state.referencePeriod
      ].slice(0, lastMonth)
      displayData.years = displayYears
      displayData.years[yearIndex].months = displayMonths
      displayData.years[yearIndex].reference_deltas[
        this.state.referencePeriod
      ] = displayDeltas
    }

    this.setState({ displayData: displayData }, () => {
      this.setState(
        {
          chartOptions: this.getOption()
        },
        () => {
          this.setState({
            echartInstance: this.echarts_react.getEchartsInstance()
          })
        }
      )
    })
  }

  setHighlight(highlightTemp) {
    // console.log('highlightTemp:', this.state.highlightTemp)
    // console.log('zoom start:', this.state.zoomStart)
    // console.log('zoom start:', this.state.zoomEnd)
    this.setState(
      {
        highlightTemp: highlightTemp
      },
      () => {
        this.state.echartInstance.setOption(this.getOption())
      }
    )
  }

  formatData(data) {
    // console.log('DATA VALUES: ', data.years)
    const allMonths = []
    let itemIndex = 0
    for (let i = 0; i < months.length; i++) {
      for (let y = 0; y < data.years.length; y++) {
        // console.log('itemIndex: ', itemIndex)
        let currItem = {}
        const currDelta =
          data.years[y].reference_deltas[this.state.referencePeriod][i]
        const year = data.years[y].year
        const typeItem = this.defineType(currDelta, this.state.highlightTemp)
        // console.log('currDelta', currDelta)
        // console.log('curr highlightTemp: ', this.state.highlightTemp)
        currItem = {
          name: typeItem.name,
          value: [
            i,
            parseInt(year),
            parseInt(year) + 1,
            1,
            data.years[y].months[i]
          ],
          itemStyle: {
            normal: {
              color: typeItem.color,
              borderColor:
                itemIndex === this.state.highlightItem
                  ? '#00FCFF'
                  : 'transparent',
              borderWidth: itemIndex === this.state.highlightItem ? 2 : 0
            }
          }
        }
        allMonths.push(currItem)
        itemIndex++
      }
    }
    // console.log('°°°°° allMonths °°°°°')
    // console.log(allMonths)
    return allMonths
  }

  defineType(temperature, highlightTemp) {
    // console.log('temperature:', temperature)
    // console.log('highlightTemp:', highlightTemp)
    if (temperature === undefined) {
      return { name: 'NO DATA', color: '#333333' }
    } else {
      if (temperature < -10) {
        return {
          name: 'unter -10°',
          color:
            highlightTemp === 9999 || highlightTemp < -10
              ? '#081f45'
              : '#1f1f1f'
        }
      } else if (temperature >= -10 && temperature < -8) {
        return {
          name: '-10° bis -8°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -10 && highlightTemp < -8)
              ? '#133561'
              : '#1f1f1f'
        }
      } else if (temperature >= -8 && temperature < -6) {
        return {
          name: '-8° bis -6°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -8 && highlightTemp < -6)
              ? '#234b7b'
              : '#1f1f1f'
        }
      } else if (temperature >= -6 && temperature < -5) {
        return {
          name: '-6° bis -6°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -6 && highlightTemp < -5)
              ? '#366492'
              : '#1f1f1f'
        }
      } else if (temperature >= -5 && temperature < -4) {
        return {
          name: '-5° bis -4°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -5 && highlightTemp < -4)
              ? '#4c7da8'
              : '#1f1f1f'
        }
      } else if (temperature >= -4 && temperature < -3) {
        return {
          name: '-4° bis -3°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -4 && highlightTemp < -3)
              ? '#6697bd'
              : '#1f1f1f'
        }
      } else if (temperature >= -3 && temperature < -2) {
        return {
          name: '-3° bis -2°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -3 && highlightTemp < -2)
              ? '#83b0cf'
              : '#1f1f1f'
        }
      } else if (temperature >= -2 && temperature < -1) {
        return {
          name: '-2° bis -1°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -2 && highlightTemp < -1)
              ? '#a3cadf'
              : '#1f1f1f'
        }
      } else if (temperature >= -1 && temperature < -0.5) {
        return {
          name: '-1° bis -0.5°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -1 && highlightTemp < -0.5)
              ? '#c8e3ef'
              : '#1f1f1f'
        }
      } else if (temperature >= -0.5 && temperature <= 0) {
        return {
          name: '-0.5° bis 0°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -0.5 && highlightTemp <= 0)
              ? '#f1fcff'
              : '#1f1f1f'
        }
      } else if (temperature > 0 && temperature < 0.5) {
        return {
          name: '0° bis 0.5°',
          color:
            highlightTemp === 9999 || (highlightTemp > 0 && highlightTemp < 0.5)
              ? '#ffffe1'
              : '#1f1f1f'
        }
      } else if (temperature >= 0.5 && temperature < 1) {
        return {
          name: '0.5° bis 1°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= 0.5 && highlightTemp < 1)
              ? '#fed5a0'
              : '#1f1f1f'
        }
      } else if (temperature >= 1 && temperature < 2) {
        return {
          name: '1° bis 2°',
          color:
            highlightTemp === 9999 || (highlightTemp >= 1 && highlightTemp < 2)
              ? '#fda67a'
              : '#1f1f1f'
        }
      } else if (temperature >= 2 && temperature < 3) {
        return {
          name: '2° bis 3°',
          color:
            highlightTemp === 9999 || (highlightTemp >= 2 && highlightTemp < 3)
              ? '#ef7967'
              : '#1f1f1f'
        }
      } else if (temperature >= 3 && temperature < 4) {
        return {
          name: '3° bis 4°',
          color:
            highlightTemp === 9999 || (highlightTemp >= 3 && highlightTemp < 4)
              ? '#d45059'
              : '#1f1f1f'
        }
      } else if (temperature >= 4 && temperature < 5) {
        return {
          name: '4° bis 5°',
          color:
            highlightTemp === 9999 || (highlightTemp >= 4 && highlightTemp < 5)
              ? '#b22d45'
              : '#1f1f1f'
        }
      } else if (temperature >= 5 && temperature < 6) {
        return {
          name: '5° bis 6°',
          color:
            highlightTemp === 9999 || (highlightTemp >= 5 && highlightTemp < 6)
              ? '#8a102b'
              : '#1f1f1f'
        }
      } else if (temperature >= 6) {
        return {
          name: '>6°',
          color:
            highlightTemp === 9999 || highlightTemp >= 6 ? '#5e0204' : '#2E2E2E'
        }
      } else {
        // console.log('!!! ERROR !!!')
        return { name: 'ERROR', color: '#00ff00' }
      }
    }
  }

  // Chart Options
  // https://ecomfe.github.io/echarts-doc/public/en/option.html#title
  getOption = () => ({
    tooltip: {
      /*
      axisPointer: {
        snap: true,
        type: 'line'
      },
      trigger: 'item',
      textStyle: {
        color: '#333'
      },
      */
      backgroundColor: '#f3f3f3',
      formatter: function(params, ticket, callback) {
        // console.log('#### params ####', params)
        this.setState(
          {
            highlightItem: params.dataIndex
          },
          () => {
            // console.log('#### highlightItem ####', this.state.highlightItem)
            this.state.echartInstance.setOption(this.getOption())
          }
        )
        const monthIndex = params.value[0]
        const currMonth = monthNames[monthIndex]
        const currYear = params.value[1]
        const firstYear = this.state.displayData.years[0].year
        const currYearIndex = currYear - firstYear
        const currTemp = params.value[4]
        const currDiff = parseFloat(
          this.state.displayData.years[currYearIndex].reference_deltas[
            this.state.referencePeriod
          ][monthIndex]
        ).toFixed(1)
        const displayDiff = currDiff > 0 ? '+' + currDiff : currDiff
        const title =
          '<div class="tip-title"><strong>' +
          currMonth +
          '</strong> | ' +
          currYear +
          '</div>'

        let tooltipContent = title + '<hr class="under" />'
        tooltipContent += '<div class="row">'
        tooltipContent += 'Abweichung:  '
        tooltipContent +=
          '<span class="weighted">' +
          displayDiff +
          ' °C</span><br />vom langjährigen Mittel</div>'
        tooltipContent += '<div class="row">'
        tooltipContent += 'Ø-Temperatur: '
        tooltipContent +=
          '<span class="weighted">' + currTemp + '°C</span></div>'

        // callback(console.log('scrubbed to: ', params[0].dataIndex))
        if (currTemp !== null && currTemp !== undefined) {
          return tooltipContent
        }
      }.bind(this)
    },
    dataZoom: [
      {
        type: 'slider',
        filterMode: 'filter',

        start: this.state.zoomStart >= 0 ? this.state.zoomStart : 54,
        end: this.state.zoomEnd >= 0 ? this.state.zoomEnd : 100, // ~70 years range
        /*
        startValue: parseInt(
          Object.keys(this.state.displayData.years)[
            Object.keys(this.state.displayData.years).length - 1
          ]
        ), // 2020
        endValue: parseInt(Object.keys(this.state.displayData.years)[0]), // 1864
        */

        minValueSpan: 20,
        maxValueSpan: Object.keys(this.state.displayData.years).length, // 157
        labelPrecision: 10,
        showDataShadow: false,
        bottom: 20,
        height: 10,
        left: 15,
        right: 30,
        borderColor: 'transparent',
        backgroundColor: '#222222',
        handleIcon: 'image://' + require('./images/handle.svg'),
        handleSize: 20,
        labelFormatter: ''
      }
    ],
    grid: [
      {
        top: this.state.isMobile ? '5%' : '5%',
        left: 15,
        right: 0,
        bottom: 40,
        containLabel: true
      }
    ],
    xAxis: {
      min: parseInt(this.state.displayData.years[0].year), // 1864
      max:
        parseInt(
          this.state.displayData.years[this.state.displayData.years.length - 1]
            .year
        ) + 1, // 2021
      position: 'top',
      scale: true,
      axisLabel: {
        formatter: function(params) {
          // return parseInt(params)
          return params
        },
        position: 'left',
        padding: [0, 0, 0, 2],
        color: '#ffffff',
        showMaxLabel: false,
        showMinLabel: false
      },
      axisTick: {
        show: true,
        alignWithLabel: true,
        lineStyle: {
          color: '#ffffff'
        }
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      inverse: true,
      position: 'right',
      data: months,
      axisLabel: {
        verticalAlign: 'middle',
        padding: [0, 0, -1, 0],
        color: '#ffffff'
      }
    },
    series: [
      {
        type: 'custom',
        renderItem: renderItem,
        itemStyle: {
          opacity: 1
        },
        encode: {
          x: [1, 2],
          y: 0
        },
        data: this.formatData(this.state.displayData),
        animation: false
      }
    ]
  })

  render() {
    // console.log('### DATA ###', this.state.displayData)
    // register theme object
    // theme object format example: https://github.com/apache/incubator-echarts/blob/master/theme/dark.js
    echarts.registerTheme('ta_theme', {
      backgroundColor: 'transparent',
      textStyle: {
        fontSize: '16',
        fontFamily:
          'TamediaChart,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif',
        color: '#333'
      },
      title: {
        textStyle: {
          color: '#333',
          fontSize: '22'
        },
        subtextStyle: {
          color: '#5f5f5f',
          fontSize: '18'
        }
      },
      legend: {
        left: 'left',
        orient: 'vertical',
        itemGap: 7,
        padding: [0, 0, 0, 10],
        itemWidth: 10,
        textStyle: {
          fontSize: '16'
        },
        show: false
      },
      label: {
        show: false
      },
      smooth: true
    })

    return (
      <div className='echart temp-stripes'>
        <h3>{this.props.title}</h3>
        <h5>{this.props.subtitle}</h5>
        <ReactEcharts
          ref={e => {
            this.echarts_react = e
          }}
          onEvents={this.handleEvents}
          option={this.state.chartOptions}
          opts={{ renderer: 'canvas' }}
          notMerge
          lazyUpdate
          theme='ta_theme'
          style={{ height: this.state.isMobile ? '20em' : '23em' }}
        />
        <div className='scale'>
          <div className='wrapper'>
            <div
              className={
                this.state.highlightTemp === -11 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#081f45' }}
              onMouseEnter={() => this.setHighlight(-11)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={this.state.highlightTemp === -9 ? 'box active' : 'box'}
              style={{ backgroundColor: '#133561' }}
              onMouseEnter={() => this.setHighlight(-9)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={this.state.highlightTemp === -7 ? 'box active' : 'box'}
              style={{ backgroundColor: '#234b7b' }}
              onMouseEnter={() => this.setHighlight(-7)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -5.5 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#366492' }}
              onMouseEnter={() => this.setHighlight(-5.5)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -4.5 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#4c7da8' }}
              onMouseEnter={() => this.setHighlight(-4.5)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -3.5 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#6697bd' }}
              onMouseEnter={() => this.setHighlight(-3.5)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -2.5 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#83b0cf' }}
              onMouseEnter={() => this.setHighlight(-2.5)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -1.5 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#a3cadf' }}
              onMouseEnter={() => this.setHighlight(-1.5)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -0.75 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#c8e3ef' }}
              onMouseEnter={() => this.setHighlight(-0.75)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -0.25 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#f1fcff' }}
              onMouseEnter={() => this.setHighlight(-0.25)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 0.25 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#ffffe1' }}
              onMouseEnter={() => this.setHighlight(0.25)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 0.75 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#fed5a0' }}
              onMouseEnter={() => this.setHighlight(0.75)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 1.5 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#fda67a' }}
              onMouseEnter={() => this.setHighlight(1.5)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 2.5 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#ef7967' }}
              onMouseEnter={() => this.setHighlight(2.5)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 3.5 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#d45059' }}
              onMouseEnter={() => this.setHighlight(3.5)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 4.5 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#b22d45' }}
              onMouseEnter={() => this.setHighlight(4.5)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 5.5 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#8a102b' }}
              onMouseEnter={() => this.setHighlight(5.5)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={this.state.highlightTemp === 7 ? 'box active' : 'box'}
              style={{ backgroundColor: '#5e0204' }}
              onMouseEnter={() => this.setHighlight(7)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
          </div>
        </div>
        <div className='legends'>
          <div className='box'>
            <span className='left wide'>&lt;</span>
          </div>
          <div className='box'>
            <span className='left wide'>-10</span>
          </div>
          <div className='box'>
            <span className='left'>-8</span>
          </div>
          <div className='box'>
            <span className='left'>-6</span>
          </div>
          <div className='box'>
            <span className='left'>-5</span>
          </div>
          <div className='box'>
            <span className='left narrow'>-4</span>
          </div>
          <div className='box'>
            <span className='left narrow'>-3</span>
          </div>
          <div className='box'>
            <span className='left minimal'>-2</span>
          </div>
          <div className='box'>
            <span className='left minimal'>-1</span>
          </div>
          <div className='box'>
            <span>-0,5</span>
          </div>
          <div className='box'>
            <span>0</span>
          </div>
          <div className='box'>
            <span>+0.5</span>
          </div>
          <div className='box'>
            <span className='right minimal'>+1</span>
          </div>
          <div className='box'>
            <span className='right minimal'>+2</span>
          </div>
          <div className='box'>
            <span className='right minimal'>+3</span>
          </div>
          <div className='box'>
            <span className='right narrow'>+4</span>
          </div>
          <div className='box'>
            <span className='right narrow'>+5</span>
          </div>
          <div className='box'>
            <span className='right'>+6</span>
          </div>
          <div className='box'>
            <span className='right wide'>&gt;</span>
          </div>
        </div>
        <div className='source'>
          Quelle:{' '}
          {/* }
          <Link href='https://www.meteoschweiz.admin.ch/home/klima/schweizer-klima-im-detail/homogene-messreihen-ab-1864.html?region=Tabelle'>
            Meteoschweiz
          </Link>
        */}
          Meteoschweiz
        </div>
      </div>
    )
  }
}
